<script src="./AboutUs.js"></script>

<template>

<div>
    <transition name="slide-fade" appear>
      <vueper-slides autoplay class="slider-area" :arrows="false" :pause-on-hover="false" :fade="true"
        :bulletsOutside="true">
        <vueper-slide v-for="(slide, i) in imageData" :key="i" :title="slide.fields.imageText" 
        v-bind:style="{'background-image':`url(${slide.fields.sliderImage.fields.file.url})`}"
        class="single-slider bg-img slider-height-2 align-items-center custom-d-flex">
              <div class="container">
                <div class="row height-100-percent align-items-center">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="slider-content-8 slider-animated-1 text-center">
                        <h3 class="animated">{{slide.fields.imageText}}</h3>
                    </div>
                  </div>
                </div>
              </div>
        </vueper-slide>
      </vueper-slides>
    </transition>
    <div class="container">
        <div class="slider-area text-center mb-4 pb-2 mt-4">
        <h2 class="text">{{text}}</h2>
        <p>{{ contentVal }}</p>
    </div>
  </div>
  </div>

</template>
